/**
 * 가상 샘플임을 화면에서 지울 수 없게 고정 표시한다.
 * 요건: 샘플을 실경매 물건처럼 보이게 하지 않는다.
 */
export default function SampleBanner() {
  return (
    <div className="mb-5 rounded-2xl border border-warn/30 bg-warn-soft px-4 py-3 text-[13px] leading-relaxed text-warn">
      <strong className="font-bold">가상 샘플 데이터</strong> — 실제 경매 물건이
      아닙니다. 사건번호와 단지명은 검증용으로 만든 값이며 입찰 판단에 사용할 수
      없습니다.
    </div>
  );
}
